module.exports = __webpack_public_path__ + "img/01宋雷.e09b9b62.png";